import { render, staticRenderFns } from "./OfficerTasks.vue?vue&type=template&id=0248a7fa"
import script from "./OfficerTasks.vue?vue&type=script&lang=js"
export * from "./OfficerTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports